module.exports = __webpack_public_path__ + "../resources/img/img_ef_layer3_no-inverter-no-battery-no-grid_lt 1.facc53ce.svg";